import { Component } from '@angular/core';

@Component({
    selector: 'ndd-page-reload',
    template: require('./page-reload.component.html'),
})
export class PageReloadComponent { }
